import React, { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Briefcase, ExternalLink } from 'lucide-react';
import { projects } from '../mock';

export const Portfolio = () => {
  const [filter, setFilter] = useState('All');
  const categories = ['All', 'Custom Software', 'Web Application', 'Mobile Development', 'Cloud Services'];

  const filteredProjects = filter === 'All' 
    ? projects 
    : projects.filter(p => p.category === filter);

  return (
    <div className="min-h-screen pt-24 pb-16">
      <div className="container mx-auto px-6">
        {/* Hero Section */}
        <div className="max-w-4xl mx-auto text-center mb-12 animate-slide-up">
          <div className="w-20 h-20 bg-[rgba(0,168,255,0.2)] rounded-2xl flex items-center justify-center mx-auto mb-6" style={{ boxShadow: '0 0 30px rgba(0,168,255,0.5)' }}>
            <Briefcase className="text-[#00a8ff]" size={40} style={{ filter: 'drop-shadow(0 0 10px #00a8ff)' }} />
          </div>
          <h1 className="text-5xl md:text-6xl font-bold led-text animate-led-pulse mb-6" style={{ textShadow: '0 0 20px #00a8ff, 0 0 40px #4cd3ff' }}>
            OUR PORTFOLIO
          </h1>
          <p className="text-xl text-[#00a8ff]" style={{ textShadow: '0 0 10px #00a8ff' }}>
            Showcasing innovative solutions delivered to clients worldwide
          </p>
        </div>

        {/* Filter Section */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setFilter(category)}
              className={`px-6 py-3 rounded-lg text-sm font-bold transition-all duration-300 border-2 ${
                filter === category
                  ? 'bg-[#00a8ff] text-[#0a2540] border-[#00a8ff] shadow-[0_0_20px_#00a8ff]'
                  : 'bg-[rgba(0,168,255,0.1)] text-[#00a8ff] border-[#00a8ff] hover:bg-[rgba(0,168,255,0.2)]'
              }`}
              style={ filter === category ? { boxShadow: '0 0 20px #00a8ff' } : {} }
            >
              {category}
            </button>
          ))}
        </div>

        {/* Projects Grid - ALWAYS VISIBLE */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project, idx) => (
            <Card key={project.id} className="group bg-[rgba(30,64,98,0.7)] border-2 border-[#00a8ff] rounded-xl overflow-hidden hover:shadow-[0_0_40px_#00a8ff] transition-all duration-300 hover:-translate-y-2 cursor-pointer" style={{ boxShadow: '0 0 15px rgba(0,168,255,0.3)' }}>
              <div className="relative overflow-hidden aspect-[4/3] bg-[rgba(10,37,64,0.7)]">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500 opacity-80"
                 width={1200} height={800} />
                <div className="absolute inset-0 bg-gradient-to-t from-[rgba(10,37,64,0.95)] via-[rgba(10,37,64,0.4)] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <div className="p-6 w-full">
                    <Badge className="bg-[#00a8ff] text-[#0a2540] border-0 font-bold mb-2" style={{ boxShadow: '0 0 15px #00a8ff' }}>{project.category}</Badge>
                    <div className="flex items-center text-[#00a8ff] font-bold">
                      View Project <ExternalLink className="ml-2" size={16} />
                    </div>
                  </div>
                </div>
              </div>
              <CardContent className="p-6">
                <div className="text-sm text-[#00a8ff] mb-2 font-bold">{project.category}</div>
                <h3 className="text-xl font-bold text-white mb-2 led-text" style={{ textShadow: '0 0 8px #00a8ff' }}>{project.title}</h3>
                <p className="text-[#00a8ff] text-sm mb-4" style={{ textShadow: '0 0 5px #00a8ff' }}>{project.description}</p>
                <div className="flex flex-wrap gap-2">
                  {project.technologies.map((tech, idx) => (
                    <Badge key={idx} className="bg-[rgba(0,168,255,0.2)] text-[#00a8ff] border border-[#00a8ff] text-xs" style={{ boxShadow: '0 0 10px rgba(0,168,255,0.3)' }}>
                      {tech}
                    </Badge>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {filteredProjects.length === 0 && (
          <div className="text-center py-12">
            <p className="text-[#00a8ff] text-lg" style={{ textShadow: '0 0 8px #00a8ff' }}>No projects found in this category.</p>
          </div>
        )}
      </div>
    </div>
  );
};
